module.exports = __webpack_public_path__ + "img/hkzc2.8435d477.jpg";